/** Redact secrets embedded in operational error strings while keeping messages readable. */

const TELEGRAM_BOT_TOKEN_RE = /\b\d{8,}:[A-Za-z0-9_-]{20,}\b/g;
const KEY_VALUE_SECRET_RE =
  /\b((?:password|passwd|token|api[_-]?key|secret|authorization)\s*[=:]\s*)(\S+)/gi;
const BEARER_RE = /\bBearer\s+[A-Za-z0-9._-]+\b/gi;

export function redactSecretsInText(text: string): string {
  if (!text) return text;
  return text
    .replace(TELEGRAM_BOT_TOKEN_RE, '[REDACTED_TOKEN]')
    .replace(KEY_VALUE_SECRET_RE, '$1[REDACTED]')
    .replace(BEARER_RE, 'Bearer [REDACTED]');
}
